import axios from 'axios';
import { CreateReleasePondsInput } from 'views/production-systems/types/locked-ponds/create-release-ponds-input.type';

// POST
// ​/ewosapi​/v1​/shrimps​/lock-ponds​/{siteId}​/release
export const postReleasePond = async (siteId: string, releasePondsRequest: CreateReleasePondsInput) => {
  const res = await axios.post(`/ewosapi/v1/shrimps/lock-ponds/${siteId}/release`, releasePondsRequest);
  return res.data;
};
